import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import fetchOgData from '../../shared/utils/og';
import getUrl from 'get-urls';

const OpenGraphPreviewComponent = ({ text }) => {
  if (!(text && text.length)) { return null; }

  const urls = getUrl(text);
  if (!urls.size) { return null; }
  const url = [...urls][0];

  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [ogData, setOgData] = useState({
    ogUrl: null,
    ogSiteName: null,
    ogTitle: null,
    ogDescription: null,
    ogImage: null,
    ogLocale: null
  });

  useEffect(() => {
    if (!loading) { setLoading(true) };
    fetchOgData(url, receiveOgData);
  }, []);

  const receiveOgData = (data) => {
    setLoading(false);

    if (data.error) {
      setFailed(true);
    } else {
      setOgData(data.meta);
    }
  }

  if (loading) {
    return (
      <div className="mt-20">
        <span className="t6 dark-gray">Loading...</span>
      </div>
    );
  }

  if (failed) {
    return null;
  }

  if (!(ogData.ogTitle && ogData.ogImage && ogData.ogDescription)) {
    return null;
  }

  return (
    <div className="activity-attachment mt-20">
      <div className="module mb-0">
        <a className="nostyle" href={ url }>
          <div className="image-flexbox">
            <img src={ ogData.ogImage.url } />
          </div>

          <div className="module-content pt-10">
            <span className="t5 w3">{ ogData.ogTitle }</span>
            <p className="t6 mb-5 line-clamp-2">{ ogData.ogDescription }</p>
            <span className="t6 dark-gray">{ (ogData.ogUrl || url).replace(/(https?\:\/\/)?(www.)?/, '') }</span>
          </div>
        </a>
      </div>
    </div>
  );
}

OpenGraphPreviewComponent.propTypes = {
};

export default OpenGraphPreviewComponent;
